module.exports = __webpack_public_path__ + "media/images/photo/la_vie_clair-992804b35c780ba46719da01e78507f6.png";